var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-chip',_vm._g(_vm._b({staticClass:"text-uppercase",staticStyle:{"width":"170px"},attrs:{"icon":"mdi-account-settings","color":"secondary","outlined":"","small":"","label":false}},'avs-chip',{ ..._vm.$attrs },false),{ ..._vm.$listeners }),[_vm._v(" "+_vm._s(_vm.get_status(_vm.role))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }